import React, { useEffect, useState } from "react";
import { getSignalPreview, abortTrade, rejectSignal } from "../services/api.js";
import { useToasts } from "./ToastHost.js";

export default function SignalPreview(){
  const [signals,setSignals]=useState([]);
  const [loading,setLoading]=useState(false);
  const [error,setError]=useState("");
  const { push } = useToasts();

  async function load(){
    try{ setLoading(true); setError("");
      const data=await getSignalPreview();
      setSignals(data.preview_trades||[]);
    }catch(e){ setError(e.message||"Fehler beim Laden"); }
    finally{ setLoading(false); }
  }
  useEffect(()=>{ load(); },[]);

  const handleAbort=async(signal)=>{
    try{ await abortTrade(signal); setSignals(prev=>prev.filter(s=>s!==signal)); push("Trade-Abbruch ausgelöst"); }
    catch(e){ push(`Fehler: ${e.message}`,"error"); }
  };
  const handleReject=async(signal)=>{
    try{ await rejectSignal(signal); setSignals(prev=>prev.filter(s=>s!==signal)); push("Signal abgelehnt"); }
    catch(e){ push(`Fehler: ${e.message}`,"error"); }
  };

  return (
    <div className="card">
      <div className="flex items-center justify-between mb-3">
        <h2 className="text-xl font-semibold">Signal-Vorschau</h2>
        <button className="btn btn-muted" onClick={load}>Neu laden</button>
      </div>
      {loading && <div className="text-sm opacity-70">Lade…</div>}
      {error && <div className="text-sm text-red-600">Fehler: {error}</div>}
      {!loading && !signals.length && <div className="text-sm opacity-70">Keine Signale aktuell</div>}
      {!!signals.length && (
        <div className="overflow-x-auto">
          <table className="w-full text-sm border-collapse">
            <thead><tr className="bg-gray-100">
              <th className="border px-2 py-1">Ticker</th>
              <th className="border px-2 py-1">Richtung</th>
              <th className="border px-2 py-1">Entry</th>
              <th className="border px-2 py-1">SL</th>
              <th className="border px-2 py-1">TP</th>
              <th className="border px-2 py-1">Confidence</th>
              <th className="border px-2 py-1">Aktionen</th>
            </tr></thead>
            <tbody>
              {signals.map((s,i)=>(
                <tr key={`${s.ticker}-${i}`}>
                  <td className="border px-2 py-1">{s.ticker}</td>
                  <td className="border px-2 py-1">{s.side}</td>
                  <td className="border px-2 py-1">{s.entry}</td>
                  <td className="border px-2 py-1">{s.sl}</td>
                  <td className="border px-2 py-1">{s.tp}</td>
                  <td className="border px-2 py-1">{(s.confidence*100).toFixed(1)}%</td>
                  <td className="border px-2 py-1">
                    <div className="flex gap-2">
                      <button className="btn btn-danger" onClick={()=>handleAbort(s)}>Trade abbrechen</button>
                      <button className="btn btn-muted" onClick={()=>handleReject(s)}>Signal ablehnen</button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}